export type OrgaizationKeys = "private" | "public";
export type OrgaizationValues = "PRIVATE" | "PUBLIC";

export const OrganizationSectors: Record<OrgaizationKeys, OrgaizationValues> = {
	public: "PUBLIC",
	private: "PRIVATE",
};